import React, { useState } from 'react'
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { useResponsiveTypography } from '../../utility/responsiveTypography'

const OptionMenu = ({ options, onOptionSelect, tooltipContent }) => {
  const { menutitle } = useResponsiveTypography()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleSelectOption = (option) => {
    onOptionSelect(option)
    handleCloseMenu()
  }

  return (
    <>
      <Tooltip title={tooltipContent || ''} placement="left">
        <IconButton onClick={handleOpenMenu} size="small" style={{ height: 28, width: 28 }}>
          <MoreVertIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            disabled={option.disabled}
            key={index}
            onClick={() => handleSelectOption(option.id)}
            sx={{ textAlign: 'left' }}
          >
            {option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
            <ListItemText
              primary={option.title}
              primaryTypographyProps={{ sx: { fontSize: menutitle } }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default OptionMenu
